import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M7.21875 2.5625C7.375 2.21875 7.71875 2 8.09375 2L11.875 2C12.25 2 12.5938 2.21875 12.75 2.5625L13 3L16 3C16.5312 3 17 3.46875 17 4C17 4.5625 16.5312 5 16 5L4 5C3.4375 5 3 4.5625 3 4C3 3.46875 3.4375 3 4 3L7 3L7.21875 2.5625ZM16 6L15.3125 16.5938C15.2813 17.4062 14.625 18 13.8125 18H6.15625C5.34375 18 4.6875 17.4062 4.65625 16.5938L4 6L16 6Z"
	})
});
const ForwardRef = forwardRef(SvgTrashFilled);
export default ForwardRef;
